import { render, staticRenderFns } from "./PreNotRegistered.vue?vue&type=template&id=4c1bb432&scoped=true&"
import script from "./PreNotRegistered.vue?vue&type=script&lang=js&"
export * from "./PreNotRegistered.vue?vue&type=script&lang=js&"
import style0 from "./PreNotRegistered.vue?vue&type=style&index=0&id=4c1bb432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1bb432",
  null
  
)

export default component.exports